import axios from 'axios';
import * as endpoints from './const';
import { uniqBy, isEmpty, filter, matches, includes, orderBy, find, forEach,cloneDeep } from 'lodash';
const querystring = require('querystring');

// const getApiUrl = ({ endPoint, id, startDate, endDate, countryCode, companyCode }) => {
//   let url = endPoint + `?id=${id}`;
//   if (countryCode) url += `&countryCode=${countryCode}`;
//   if (companyCode) url += `&companyCode=${companyCode}`;
//   if (startDate) url += `&startDate=${startDate}`;
//   if (endDate) url += `&endDate=${endDate}`;
//   return url;
// };

class CorporateQuoteWorkflowSetupApi {
  static getWorkflowList(params) {
    //return true;
    return axios
      .get(endpoints.CORPORATE_QUOTE_WORKFLOW_SETUP_LIST, {
        params
      })
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getAssigneeList(params){
    const url = endpoints.CORPORATE_QUOTE_WORKFLOW_SETUP_ASSIGNEE + '?limit=10000';
    return axios.get(url,{params})
      .then(response => response.data)
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        throw(error);
      }); 
  }

  static createNewWorkflow(workflow){
    const url = endpoints.CORPORATE_QUOTE_WORKFLOW_SETUP_WORKFLOW;
    var remoteFn=workflow.Id && parseInt(workflow.Id)>0?axios.put:axios.post;
    
    return remoteFn(url,workflow)
      .then(response=>response.data)
      .catch(error=>{
        throw(error);
      });
  }

  static saveApproverDetail(approverDetail,workflow){
    const url = endpoints.CORPORATE_QUOTE_WORKFLOW_SETUP_APPROVER;
    let remoteFn=approverDetail.Id && parseInt(approverDetail.Id)>0?axios.put:axios.post;
    let approverInfo=cloneDeep(approverDetail);
    approverInfo.User_Id=approverDetail.User.Id;
    approverInfo.Workflow_Id=workflow.Id;
    return remoteFn(url,approverInfo)
      .then(response=>response.data)
      .catch(error=>{
        throw(error);
      });
  }

  static deleteApproverDetail(approverDetail,workflow){
    const url =`${endpoints.CORPORATE_QUOTE_WORKFLOW_SETUP_APPROVER}/${approverDetail.Id}`;
    
    return axios.delete(url)
      .then(response=>response.data)
      .catch(error=>{
        throw(error);
      });
  }
  
}

export default CorporateQuoteWorkflowSetupApi;




// WEBPACK FOOTER //
// ./src/api/CorporateQuoteWorkflowSetupApi.js